// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --configuration=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// Also see https://angular.io/guide/build#configuring-application-environments

export const environment = {
  production: false,
  baseUrl: 'https://test.ecarup.com/',
  stripe_publishable_key: 'pk_test_vml61AcmdhuChff9lihi2ir6',
  posthogKey: 'phc_zPVq4h3x7HjANLJDdQKfiMsYwqxJdT9TXivZ59cCnezT',
  posthogHost: 'https://eu.i.posthog.com',
  name: 'test',
};
